export default function getInitState() {
    return {
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                event_name: "customClick",
                class: "btn btn-outline-success",
                seeDefinitely: true,
                event_payload: 'seeRow'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "Azonosító",
                visibility: false,
                sort: false,
                viewModalShow: true
            },
            {
                name: "request",
                label: "Kérés",
                visibility: true,
                sort: false,
                viewModalShow: true,
                formVisible: true,
                formType: "text",
                formSize: "6"
            },
            {
                name: "response",
                label: "Válasz",
                visibility: true,
                sort: false,
                viewModalShow: true,
                formVisible: true,
                formType: "text",
                formSize: "6"
            },
            {
                name: "createdOn",
                label: "History készítésének dátuma",
                visibility: true,
                slot_name: "date_format",
                sort: false,
                viewModalShow: true,
                formType: "date",
                formVisible: true,
                formSize: "2",
                
            },
            {
                name: "status",
                label: "Státusz",
                visibility: true,
                sort: false,
                viewModalShow: true,
                formVisible: true,
                formType: "select",
                formSize: "2",
                selectOptions: {
                    externalOptionList: [
                        {
                            id: "1",
                            text: 'OK',
                        },
                        {
                            id: "2",
                            text: 'Created',
                        },
                        {
                            id: "3",
                            text: 'Bad Request',
                        },
                        {
                            id: "4",
                            text: 'Unauthorized',
                        },
                        {
                            id: "5",
                            text: 'Forbidden',
                        },
                        {
                            id: "6",
                            text: 'Not Found',
                        },
                        {
                            id: "7",
                            text: 'Conflict',
                        },
                        {
                            id: "8",
                            text: 'Internal Server Error',
                        }
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "direction",
                label: "Irány",
                visibility: true,
                sort: false,
                viewModalShow: true,
                formVisible: true,
                formType: "select",
                formSize: "2",
                selectOptions: {
                    externalOptionList: [
                        {
                            id: "1",
                            text: 'IN',
                        },
                        {
                            id: "2",
                            text: 'OUT',
                        }
                    ],
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
        ]
    }
}
